// removed by extract-text-webpack-plugin
module.exports = {"overlay":"popup__overlay--BXhLM","popup":"popup__popup--1R583"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Popup/popup.css
// module id = 6ZAe
// module chunks = 0